<div class="dialog">
  <h4 mat-dialog-title>{{ 'dialog_family_title' | translate }}</h4>
  <form #form="ngForm">
    <mat-card>
      <mat-form-field>
        <mat-label>{{ 'common_field_code' | translate }}</mat-label>
        <input matInput type="text" [(ngModel)]="data?.family.code" name="code" cdkFocusInitial required />
        <mat-error *ngIf="!data?.family?.code" [innerHTML]="'common_error_code_required' | translate"></mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'common_field_label' | translate }}</mat-label>
        <input matInput type="text" [(ngModel)]="data?.family.displayName" name="displayName" required />
        <mat-error *ngIf="!data?.family?.displayName" [innerHTML]="'dialog_scenario_error_label_required' | translate"></mat-error>
      </mat-form-field>
    </mat-card>

    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button *ngIf="data?.family?.familyId" mat-button (click)="onClickDelete(data?.family)" color="warn">{{ 'common_btn_delete' | translate }}</button>
      <button mat-button [mat-dialog-close]="data?.family" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
